<script lang="ts">
  import type { HeroTitle } from "../../../types/entries";
  export let hero_title: HeroTitle[];
  export let id: string = "hero-title";
  export let type: string = "hero_title";
</script>

{#each hero_title || [] as title}
  {#if title.text_style.value === "hollow"}
    <h1 class="text-hero1 font-extrabold mb-4 uppercase">
      <span class="hollow-text">{title.text}</span><br />
    </h1>
  {:else if title.text_style.value === "hollow-italic"}
    <h1 class="text-hero1 font-extrabold mb-4 uppercase italic">
      <span class="hollow-text">{title.text}</span><br />
    </h1>
  {:else if title.text_style.value === "solid"}
    <h1 class="text-hero1 font-extrabold mb-4 uppercase">
      {title.text}<br />
    </h1>
  {:else if title.text_style.value === "hero2"}
    <h2 class="text-hero-2 mb-4 font-extralight text-balance">
      {title.text}<br />
    </h2>
  {:else if title.text_style.value === "leader"}
    <h2 class="text-h2 tracking-widest font-extralight uppercase">
      {title.text}<br />
    </h2>
  {:else if title.text_style.value === "body-large"}
    <h2 class="text-body-large mb-4 leading-relaxed font-extralight">
      {title.text}<br />
    </h2>
  {/if}
{/each}

<style>
  .hollow-text {
    -webkit-text-stroke: 1px #fff;
    text-stroke: 1.5px #fff;
    text-transform: uppercase;
    font-weight: 900;
    color: transparent;
  }
</style>
